module.exports = __webpack_public_path__ + "img/donate_bdnbd.723c69b3.png";